import { createSlice } from "@reduxjs/toolkit";
import { parseJwt, isTokenExpired } from "@/utils/jwt";

const TOKEN_KEY = "access-token";

const loadInitialState = () => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      const user = parseJwt(token);
      if (!isTokenExpired(user.exp)) {
        return { user, isAuthenticated: true, error: null };
      }
    }
  } catch { }
  return { user: null, isAuthenticated: false, error: null };
};

const authSlice = createSlice({
  name: "auth",
  initialState: loadInitialState(),
  reducers: {
    setAuthenticated: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.error = null;
    },
    clearAuthenticated: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setAuthError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setAuthenticated, clearAuthenticated, setAuthError, clearError } = authSlice.actions;
export default authSlice.reducer;
